import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { UnauthorizedComponent } from './common-components/unauthorized/unauthorized.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { HomeComponent } from './main-layout/home/home.component';
// import { AggregatorComponent } from './auth/aggregator/aggregator.component';
import { DeveloperComponent } from './auth/developer/developer.component';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '', component: HomeComponent,
      },
      { path: 'login', component: DeveloperComponent },
      // { path: 'aggregator', component: AggregatorComponent },
      { path: 'developer', component: DeveloperComponent },

      // { path: 'rera/agent', component: ReraAgentComponent },
      // { path: 'rera/promotors', component: ReraPromotersComponent }
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'sales', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./main-layout/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { roles: ['View_Dashboard_Acquisition', 'View_Dashboard_Sale', 'View_Dashboard_Inventory'], hideHeader: true },
        canActivate: [AuthGuard]
      },
      {
        path: 'sales',
        loadChildren: () => import('./main-layout/sales/sales.module').then(m => m.SalesModule),
        data: { roles: ['Receipt_Read_Self', 'Booking_Read_Self', 'Client_Read_Self', 'Allotment_Read_Self', 'Payment_Plan_Read'] },
        canActivate: [AuthGuard]
      },
      {
        path: 'crm',
        loadChildren: () => import('./main-layout/crm/crm.module').then(m => m.CrmModule),
        data: { roles: ['Receipt_Read_Self', 'Booking_Read_Self', 'Client_Read_Self', 'Allotment_Read_Self', 'Payment_Plan_Read', 'Unit_Category_Read'] },
        canActivate: [AuthGuard]
      },
      {
        path: 'accounts',
        loadChildren: () => import('./main-layout/accounts/accounts.module').then(m => m.AccountsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'manage',
        loadChildren: () => import('./main-layout/manage/manage.module').then(m => m.ManageModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'acquisition',
        loadChildren: () => import('./main-layout/acquisition/acquisition.module').then(m => m.AcquisitionModule),
        data: { roles: ['View_Farmer', 'View_Khata', 'View_Khasra'], hideHeader: true },
        canActivate: [AuthGuard]
      },
      {
        path: 'legal',
        loadChildren: () => import('./main-layout/legal/legal.module').then(m => m.LegalModule),
        data: { hideHeader: true } // roles: ['View_Legal_Rera', 'View_Rera_Form', 'View_Rera_Agent', 'View_Rera_Promoter'] },
        // canActivate: [AuthGuard]
      },
      {
        path: 'document',
        loadChildren: () => import('./main-layout/documents/document.module').then(m => m.DocumentModule),
        data: { hideHeader: true } // roles: ['View_Legal_Rera', 'View_Rera_Form', 'View_Rera_Agent', 'View_Rera_Promoter'] },
        // canActivate: [AuthGuard]
      },
      {
        path: 'project',
        loadChildren: () => import('./main-layout/projects/projects.module').then(m => m.ProjectsModule),
        data: { roles: ['Projects_View', 'Projects_Add', 'Projects_Edit', 'Projects_Delete'], hideHeader: true },
        canActivate: [AuthGuard]
      },
      {
        path: 'realization',
        loadChildren: () => import('./main-layout/realization/realization.module').then(m => m.RealizationModule),
        data: { roles: ['Realization_View', 'Realization_Add', 'Realization_Edit', 'Realization_Delete'], hideHeader: true },
        canActivate: [AuthGuard]
      },
      {
        path: 'explorations',
        loadChildren: () => import('./main-layout/explorations/explorations.module').then(m => m.ExplorationsModule),
        data: { roles: ['Explorations_View', 'Explorations_Add', 'Explorations_Edit', 'Explorations_Delete'], hideHeader: true },
        canActivate: [AuthGuard]
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      }
    ]
  },

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
